/**
 * Signifies that it's not a type info.
 */
export class NoTypeInfo {
}
